import { DateTime as DateTime$1 } from "../DateTime/index.js";
import { getTHERMSImageThumbnailUrl } from "../../modules/Files/utils/get-therms-image-thumbnail-url.js";
import { UserName } from "../../modules/Users/shared/UserName.js";
import { CommentFormModal } from "./CommentFormModal.js";
import { FilesListDisplay } from "../../modules/Files/shared/FilesListDisplay.js";
import { ShowHideMoreMask } from "../ShowHideMoreMask/index.js";
import { useCallback, useState } from "react";
import { Avatar, ContextMenu, Icon } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { MdDeleteForever, MdEdit } from "react-icons/md";
//#region src/components/Comments/Comment.tsx
var Comment = ({ body, checkCanEditComment, createdAt, createdByUser, fileUrls, id, onDelete, onEdit, title }) => {
	const [isEditOpen, setIsEditOpen] = useState(false);
	const handleEdit = useCallback(async (values) => {
		if (!onEdit) return;
		await onEdit(values);
		setIsEditOpen(false);
	}, [onEdit]);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
		className: "gap-y-xs sm:gap-x-sm relative flex flex-col sm:flex-row sm:gap-y-0",
		children: [
			/* @__PURE__ */ jsx(Avatar, {
				url: getTHERMSImageThumbnailUrl(createdByUser?.avatarUrl),
				circular: true,
				size: "sm"
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex w-full flex-col overflow-auto",
				children: [
					title && /* @__PURE__ */ jsx("div", { children: title }),
					/* @__PURE__ */ jsxs("div", {
						className: "inline-flex flex-wrap-reverse items-baseline",
						children: [!!createdByUser && /* @__PURE__ */ jsx("span", {
							className: "mr-xs font-bold",
							children: /* @__PURE__ */ jsx(UserName, { user: createdByUser })
						}), /* @__PURE__ */ jsx("span", {
							className: "text-color-subtle text-sm",
							children: /* @__PURE__ */ jsx(DateTime$1, {
								relative: true,
								timestamp: createdAt
							})
						})]
					}),
					/* @__PURE__ */ jsx(ShowHideMoreMask, { children: /* @__PURE__ */ jsx("div", {
						className: "mt-xxs min-w-0 whitespace-pre-wrap break-words",
						children: body
					}) }),
					Array.isArray(fileUrls) && !!fileUrls.length && /* @__PURE__ */ jsx(FilesListDisplay, {
						className: "mt-xs",
						fileUrls
					})
				]
			}),
			checkCanEditComment() && (!!onDelete || !!onEdit) && /* @__PURE__ */ jsxs(ContextMenu, {
				controllerPlace: "top-right",
				children: [
					!!onEdit && /* @__PURE__ */ jsx(ContextMenu.Option, {
						onClick: () => setIsEditOpen(true),
						children: /* @__PURE__ */ jsxs("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ jsx(Icon, {
								Icon: MdEdit,
								size: "sm"
							}), /* @__PURE__ */ jsx("span", {
								className: "ml-xs font-bold",
								children: "Edit"
							})]
						})
					}),
					!!onDelete && !!onEdit && /* @__PURE__ */ jsx(ContextMenu.Divider, {}),
					!!onDelete && /* @__PURE__ */ jsx(ContextMenu.Option, {
						onClick: onDelete,
						children: /* @__PURE__ */ jsxs("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ jsx(Icon, {
								Icon: MdDeleteForever,
								color: "critical"
							}), /* @__PURE__ */ jsx("span", {
								className: "ml-xs text-color-critical font-bold",
								children: "Delete"
							})]
						})
					})
				]
			})
		]
	}), !!onEdit && isEditOpen && /* @__PURE__ */ jsx(CommentFormModal, {
		commentId: id,
		initialValues: {
			body,
			fileUrls,
			id
		},
		onCancel: () => setIsEditOpen(false),
		onSubmit: handleEdit
	})] });
};
//#endregion
export { Comment };

//# sourceMappingURL=Comment.js.map